import { useMemo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import topo from "@highcharts/map-collection/countries/us/us-all.topo.json";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import BarChart from "components/core/blocks/BarChart";
import { getDSPMetricSpec } from "./metrics";
import { useAppSelector } from "redux/hooks";

const LocationChart = ({ regionData, geoData, metricOptions, onSelectMetric, selectedMetric }) => {
  const selectedMetricOptions = metricOptions.find((m) => m.value === selectedMetric);
  const marketplace = useAppSelector((state) => state.marketPlace);

  const metric = useMemo(
    () => getDSPMetricSpec(marketplace.marketPlace, selectedMetric),
    [marketplace, selectedMetric],
  );

  const options = useMemo(() => {
    if (!geoData) {
      return null;
    }

    return {
      chart: {
        map: topo,
      },
      title: {
        text: "",
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: "bottom",
        },
      },
      colorAxis: {
        minColor: "#f7f7f7",
        maxColor: metric.color,
      },
      series: [
        {
          color: "#C0C0C0",
          type: "map",
          mapData: topo,
          data: geoData,
        },
      ],
    };
  }, [geoData, metric]);

  return (
    <>
      <Row>
        <Col xs={12} lg={10}></Col>
        <Col xs={12} lg={2}>
          <Select options={metricOptions} value={selectedMetricOptions} onChange={(e) => onSelectMetric(e.value)} />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <h5 className="text-center">United States</h5>
          {options && <HighchartsReact highcharts={Highcharts} options={options} constructorType={"mapChart"} />}
        </Col>
        <Col xs={6}>
          <BarChart
            accessor={metric.accessor}
            metric={selectedMetricOptions.label}
            title={"Region"}
            data={regionData}
            colors={[metric.color]}
            categoryAccessor={(d) => d.region}
          />
        </Col>
      </Row>
    </>
  );
};

export default LocationChart;
